import { ref, computed, watch } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import router from "@/router";
import ability from '@/libs/acl/ability'
import { debounce } from 'lodash'
import useFilterCounter from '@/components/Filters/useFiltersCount'

export default function useList() {
  const refListTable = ref(null)
  const toast = useToast()

  const tableColumns = [
    {
      label: 'dmp.active',
      key: 'active',
      sortable: false
    },
    {
      label: 'dmp.name',
      key: 'name',
      sortable: false
    },
    {
      label: 'dmp.url',
      key: 'url',
      sortable: false
    },
    {
      label: 'dmp.count',
      key: 'count',
      sortable: true
    },
    {
      label: 'tenants.title',
      key: 'tenant.description',
      sortable: true
    },
  ]

  if (ability.can('update', 'Dmp') || ability.can('delete', 'Dmp')) {
    tableColumns.splice(0, 0, { label: 'actions.name', key: 'actions' })
  }

  const perPage = ref(10)
  const totalList = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('name')
  const isSortDirDesc = ref(false)

  store.dispatch('tenant/getAll')

  const tenantOptions = computed(() => store.getters['tenant/getSelectedItems'])

  const panelFilter = ref(null)
  const tenantFilter = ref(null)
  const dataMeta = computed(() => {
    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalList.value,
    }
  })

  const fetchList = (ctx, callback) => {
    store.dispatch('dmp_servers/getAll', {
      q: searchQuery.value,
      max: perPage.value,
      'page[n]': currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      id_dmp_panel: panelFilter.value,
      id_tenant: tenantFilter.value
    })
      .then(response => {
        callback(response.data)
        totalList.value = response.meta.total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error obteniendo la información',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  const refetchData = () => {
    refListTable.value.refresh()
  }

  watch([currentPage, perPage], () => {
    refetchData()
  })

  watch([searchQuery], debounce(() => {
    refetchData()
  }, 500))

  const filters = ref({})
  const filtersCount = useFilterCounter(filters)

  const buildFilters = () => {
    filters.value = {
      id_dmp_panel: panelFilter.value,
      id_tenant: tenantFilter.value
    }
    refetchData()
  }

  const clearSearchFilters = () => {
    panelFilter.value  = null;
    tenantFilter.value = null;

    buildFilters()
  }

  return {
    tableColumns,
    perPage,
    currentPage,
    totalList,
    fetchList,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refListTable,
    tenantOptions,
    panelFilter,
    tenantFilter,

    refetchData,
    clearSearchFilters,
    buildFilters,
    filtersCount
  }
}
